import React from 'react';

class ChatWindow extends React.Component {
  constructor(props) {
    super(props);
    this.chatWindow = React.createRef();
  }

  componentDidUpdate(prevProps) {
    const chatWindow = this.chatWindow.current;

    // Only scroll to bottom if new messages are added
    if (this.props.comments?.length !== prevProps.comments?.length) {
      // Automatically scroll to the bottom
      chatWindow.scrollTop = chatWindow.scrollHeight;
    }
  }

  displayDate(date) {
    const javaScriptRelease = new Date(Date.parse(date));
    const options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
      hour: "numeric",
      minute: "numeric",
      second: "numeric",
    };
    return javaScriptRelease.toLocaleString("he-He", options);
  }

  checkIfThereAreComments(comments) {
    if (comments?.length > 0) {
      return comments.reverse().map((data) => (
        <div className="message dx-theme-background-color" tabIndex={0} key={data.id}>
          <div style={{ display: 'flex', flexDirection: 'row' }}>
            <div className="name" style={{ marginLeft: '5px' }}>{data.user.username + "-"}</div>
            <div className="text">{data.comment_text}</div>
          </div>
          <div className="date">{this.displayDate(new Date(data.date * 1))}</div>
        </div>
      ));
    } else {
      return <div>לא נתקבלו תגובות</div>;
    }
  }

  render() {
    const { comments } = this.props;

    return (
      <div
        id="chat-window"
        className={"content-block dx-card responsive-paddings signers"}
        style={{
          maxHeight: '300px',
          minHeight: '120px',
          overflowY: 'auto',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
        }}
        ref={this.chatWindow}
      >
        {this.checkIfThereAreComments(comments)}
      </div>
    );
  }
}

export default ChatWindow;
